import { Skeleton } from "@/components/ui/skeleton";

export const HeroSkeleton = () => (
  <div className="min-h-screen flex flex-col items-center justify-center p-8 gap-8 bg-background">
    <Skeleton className="h-12 w-64" />
    <Skeleton className="h-6 w-96 max-w-full" />
    <Skeleton className="h-6 w-80 max-w-full" />
    <div className="flex gap-4 mt-4">
      <Skeleton className="h-12 w-32" />
      <Skeleton className="h-12 w-32" />
    </div>
  </div>
);

export const NavSkeleton = () => (
  <div className="fixed top-0 left-0 right-0 z-50 p-4 flex items-center justify-between bg-background/80 backdrop-blur-sm">
    <Skeleton className="h-10 w-32" />
    <div className="hidden md:flex gap-6">
      {[1, 2, 3, 4].map((i) => (
        <Skeleton key={i} className="h-4 w-20" />
      ))}
    </div>
    <Skeleton className="h-10 w-24" />
  </div>
);

export const CardSkeleton = () => (
  <div className="rounded-xl border border-border/50 bg-card/50 p-6 space-y-4">
    <Skeleton className="h-6 w-3/4" />
    <Skeleton className="h-4 w-full" />
    <Skeleton className="h-4 w-5/6" />
    <Skeleton className="h-4 w-2/3" />
  </div>
);

export const DashboardSkeleton = () => (
  <div className="min-h-screen p-8 bg-background">
    <NavSkeleton />
    <div className="pt-24 space-y-8">
      {/* Header */}
      <div className="flex items-center justify-between">
        <Skeleton className="h-10 w-48" />
        <Skeleton className="h-10 w-32" />
      </div>
      
      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="rounded-xl border border-border/50 bg-card/50 p-6 space-y-3">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-8 w-16" />
            <Skeleton className="h-3 w-32" />
          </div>
        ))}
      </div>
      
      {/* Table */}
      <div className="rounded-xl border border-border/50 bg-card/50 p-6 space-y-4">
        <Skeleton className="h-6 w-40" />
        <div className="space-y-3">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="flex items-center gap-4">
              <Skeleton className="h-10 w-10 rounded-full" />
              <Skeleton className="h-4 flex-1" />
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-8 w-20" />
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export const AnalyticsSkeleton = () => (
  <div className="min-h-screen p-8 bg-background">
    <NavSkeleton />
    <div className="pt-24 space-y-8">
      <Skeleton className="h-10 w-64" />
      
      {/* Charts Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {[1, 2].map((i) => (
          <div key={i} className="rounded-xl border border-border/50 bg-card/50 p-6 space-y-4">
            <Skeleton className="h-6 w-32" />
            <Skeleton className="h-64 w-full" />
          </div>
        ))}
      </div>
      
      {/* Full Width Chart */}
      <div className="rounded-xl border border-border/50 bg-card/50 p-6 space-y-4">
        <Skeleton className="h-6 w-48" />
        <Skeleton className="h-80 w-full" />
      </div>
    </div>
  </div>
);

export const PageSkeleton = () => (
  <div className="min-h-screen bg-background">
    <NavSkeleton />
    <div className="pt-24 px-8 space-y-12">
      {/* Hero Section */}
      <div className="text-center space-y-6 py-16">
        <Skeleton className="h-12 w-96 max-w-full mx-auto" />
        <Skeleton className="h-6 w-[500px] max-w-full mx-auto" />
        <Skeleton className="h-6 w-80 max-w-full mx-auto" />
      </div>
      
      {/* Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <CardSkeleton key={i} />
        ))}
      </div>
    </div>
  </div>
);

export const FormSkeleton = () => (
  <div className="min-h-screen flex items-center justify-center bg-background p-8">
    <div className="w-full max-w-md space-y-6">
      <Skeleton className="h-10 w-48 mx-auto" />
      <div className="rounded-xl border border-border/50 bg-card/50 p-6 space-y-4">
        <div className="space-y-2">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-10 w-full" />
        </div>
        <div className="space-y-2">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-10 w-full" />
        </div>
        <div className="space-y-2">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-24 w-full" />
        </div>
        <Skeleton className="h-12 w-full" />
      </div>
    </div>
  </div>
);
